import { render, staticRenderFns } from "./MilestonePart.vue?vue&type=template&id=d272601e&scoped=true&"
import script from "./MilestonePart.vue?vue&type=script&lang=js&"
export * from "./MilestonePart.vue?vue&type=script&lang=js&"
import style0 from "./MilestonePart.vue?vue&type=style&index=0&id=d272601e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d272601e",
  null
  
)

export default component.exports